export const PROBATION_REVIEW_CYCLE_CREATE = 'PROBATION_REVIEW_CYCLE_CREATE'
export const PROBATION_REVIEW_CYCLE_CREATE_PENDING = 'PROBATION_REVIEW_CYCLE_CREATE_PENDING'
export const PROBATION_REVIEW_CYCLE_CREATE_FULFILLED = 'PROBATION_REVIEW_CYCLE_CREATE_FULFILLED'
export const PROBATION_REVIEW_CYCLE_CREATE_REJECTED = 'PROBATION_REVIEW_CYCLE_CREATE_REJECTED'
